const CUSTOM_PLAN_NAME = 'custom';

export const plansWeightBasedOnSupportedFacilities = {
  free: 1,
  lite: 2,
  growth: 3,
  enterprise: 4,
  custom: 5,
};

export const subscriptionModes = {
  notPossible: 'not_possible',
  upgrade: 'upgrade',
  downgrade: 'downgrade',
};

const MONTH_INDICATOR_KEY = 'monthly';
const YEAR_INDICATOR_KEY = 'yearly';

export const isCustomPlan = plan => plan.name === CUSTOM_PLAN_NAME;

/*
Logic Table as per the story AF-1030 (https://welldev-group.atlassian.net/browse/AF-1030)
_________________________________________________________________________________________________
| oldPlan.period | newPlan.period | newPlanWeight <=> oldPlanWeight |      subscriptionMode
_________________________________________________________________________________________________
|                |                |                                 |                           |
| monthly        |     monthly    |              bigger             |          Upgrade          |
|                |                |                                 |                           |
| yearly         |     yearly     |              bigger             |          Upgrade          |
|                |                |                                 |                           |
| monthly        |     monthly    |              smaller            |          Downgrade        |
|                |                |                                 |                           |
| yearly         |     yearly     |              smaller            |          Downgrade        |
|                |                |                                 |                           |
_________________________________________________________________________________________________
|                |                |                                 |                           |
| yearly         |     monthly    |              bigger             | NOT POSSIBLE (Hide Button)|
|                |                |                                 |                           |
_________________________________________________________________________________________________
|                |                |                                 |                           |
| yearly         |     monthly    |              same               |         Upgrade           |
|                |                |                                 |                           |
| monthly        |     yearly     |              bigger             |         Upgrade           |
|                |                |                                 |                           |
| monthly        |     yearly     |              same               |         Upgrade           |
|                |                |                                 |                           |
_________________________________________________________________________________________________
|                |                |                                 |                           |
| monthly        |     yearly     |              smaller            |         Downgrade         |
|                |                |                                 |                           |
| yearly         |     monthly    |              smaller            |         Downgrade         |
|                |                |                                 |                           |
_________________________________________________________________________________________________
*/

const subscriptionModeDetector = ({ oldPlan, newPlan }) => {
  if (isCustomPlan(oldPlan)) {
    return subscriptionModes.notPossible;
  }

  if (newPlan.period === oldPlan.period) {
    if (
      plansWeightBasedOnSupportedFacilities[newPlan.name] >
      plansWeightBasedOnSupportedFacilities[oldPlan.name]
    ) {
      return subscriptionModes.upgrade;
    }

    if (
      plansWeightBasedOnSupportedFacilities[newPlan.name] <
      plansWeightBasedOnSupportedFacilities[oldPlan.name]
    ) {
      return subscriptionModes.downgrade;
    }

    if (
      plansWeightBasedOnSupportedFacilities[newPlan.name] ===
      plansWeightBasedOnSupportedFacilities[oldPlan.name]
    ) {
      return subscriptionModes.notPossible;
    }
  } else {
    if (
      oldPlan.period === YEAR_INDICATOR_KEY &&
      newPlan.period === MONTH_INDICATOR_KEY &&
      plansWeightBasedOnSupportedFacilities[newPlan.name] >
        plansWeightBasedOnSupportedFacilities[oldPlan.name]
    ) {
      return subscriptionModes.notPossible;
    }

    if (
      plansWeightBasedOnSupportedFacilities[newPlan.name] >=
      plansWeightBasedOnSupportedFacilities[oldPlan.name]
    ) {
      return subscriptionModes.upgrade;
    }

    if (
      plansWeightBasedOnSupportedFacilities[newPlan.name] <
      plansWeightBasedOnSupportedFacilities[oldPlan.name]
    ) {
      return subscriptionModes.downgrade;
    }
  }

  return subscriptionModes.notPossible;
};

export default subscriptionModeDetector;
